// Functions for Walt Disney World searches; v2.0.21
// Author: Tom Nelson, Nov 2021
var noStockDates = typeof stock !== 'undefined' && stock ? JSON.parse(stock) : {};
var noCapacityDates = typeof capacities !== 'undefined' && capacities ? JSON.parse(capacities) : [];
var noAvailabilityDates = typeof unavailableTicketDates !== 'undefined' && unavailableTicketDates ? JSON.parse(unavailableTicketDates) : {};
var datesPricedTooHigh = [];
//TODO: Hardcoded dates, take from server
var offer6f4ArrivalStart = moment('2025-05-12');
var offer6f4ArrivalEnd = moment('2025-09-20');
var fourDayFourParksArrivalStart = typeof fourdayfourparksarrivalstart !== 'undefined' ? moment(fourdayfourparksarrivalstart, 'YYYY-MM-DD') : null;
var fourDayFourParksArrivalEnd = typeof fourdayfourparksarrivalend !== 'undefined' ? moment(fourdayfourparksarrivalend, 'YYYY-MM-DD') : null;
var noCapacityInSelectedDate = false;
var noStockInSelectedDate = false;
var exception14Days = false;
var selectionValid = true;
var priceDisplayed;
var ticketdiscount = ticketdiscount || 0;
var offer6f4ModalShowAlready = false;

var getSeasonalPrice = function(age, date, duration) {
    var selectedDateFormatted = moment(date);
    var seasonalOfferEndFormatted = typeof seasonalofferend !== 'undefined' && moment(seasonalofferend, 'DD/MM/YYYY');
    var isOfferAvailableSelectedYear = seasonalOfferEndFormatted && selectedDateFormatted.year() === seasonalOfferEndFormatted.year();

    if (isOfferAvailableSelectedYear && selectedDateFormatted.isAfter(seasonalOfferEndFormatted) && duration === 14) {
        return window['offseason' + age + selectedDateFormatted.year() + '14'];
    }
    return window[age + selectedDateFormatted.year() + duration];
}
// -------------------------------------------------------------------------------------------------------------------
var waterParksOpenDate = '20210306';
var waterParksAccepted = false;

// Store active year (Ultimate)
var activeyear;

// Store active date and duration (Delta)
var activedate = $('#date').val();
var activeduration;
var activetype;

// Get current/next year
var currentyear = new Date().getFullYear()
var nextyear = currentyear + 1

// Determine if 2-Day ticket is on sale
var twoday = ($('#tickets').attr('data-ticket') == 'true');

// Determine if user is a travel agent
var agent = ($('body').attr('data-agent') == 'true');

// Determine ticket product
var magicyourway = false;
var delta = false;
var magic = false;

// MYW/Delta (EMEA) and Magic (UK & Ireland) share % of UI, so all are TPT (Theme Park Tickets) vs. Ulitmate (UK & Ireland)
var tpt = true;

// Check ticketproduct value from page
switch (ticketproduct) {
    // Magic Your Way (EMEA)
    case 'myw':
        magicyourway = true;
        break;
    // Delta (EMEA, post Oct '18)
    case 'delta':
        delta = true;
        break;
    // Magic (UK & Ireland, post Nov '21)
    case 'magic':
        magic = true;
        break;
    // Ultimate (UK & Ireland)
    default:
        tpt = false;
        break;
}

// Which date input method are we using?
var dateinput;
// Varies by ticket product
if (delta||magic) { dateinput = 'calendar' } // Delta/Magic use calendar for all devices
else { dateinput = 'menu' } // MYW/Ultimate use drop menus

// Arrays to store core/buffer dates and prices (Delta only)
var coreDates = [];
var bufferDates = [];
var pricingCache = [];

// Delta pricing API
var ticketsAPI = '/walt-disney-world/api/tickets/price/'

// Delta pricing API use jQuery AJAX, so set 4s timeout on calls
$.ajaxSetup({ timeout: 4000 }); // Milliseconds

var giftCardModalForceContinue = false;
var offer6f4ModalForceContinue = false;
// -------------------------------------------------------------------------------------------------------------------

// Manage tickets based on input values

// Manage tappable guest selection (Delta)
function selectguests(tap) {

    // Find .selector wrapper
    var selector = tap.closest('.selector');

    // Plus or minus?
    var action = tap.attr('data-modify');

    var sum = selectedGuestCount();

    if (action == 'plus') {
        if (sum + 1 > 10) {
            setModalForTicketsMaxPassengersError();
            return;
        }
    }
    else {
        if (sum - 1 > 10) {
            setModalForTicketsMaxPassengersError();
            return;
        }
    }

    // Find associated form input and display count
    var input = selector.find('input');
    var count = selector.find('.count');
    // Get current value, maximum, minimum
    var value = input.val();
    var minimum = parseInt(input.attr('min'));
    var maximum = parseInt(input.attr('max'));

    // Increment/decrement
    switch (action) {
        // Increment
        case 'plus':
            value++
            break;
        // Decrement
        case 'minus':
            value--
            break;
    }
    // Values within limits?
    if ((value >= minimum) && (value <= maximum)) {
        // Within limits so update
        input.val(value).change(); // Programtically fire 'change' event to force tickets() function
        count.html(value);
    }
}

// Toggle entitlements panel (mobile)
function entitlements(panel) {
    panel.toggleClass('open'); panel.find('a.norgie').toggleClass('open'); panel.find('.grid, .icons').slideToggle(); // Toggle
}

function selectionWithin6f4Offer() {
    var selectedDate = moment(activedate, 'D-M-YYYY');
    if ( $('#upsell-offer-6f4-tickets').length && offer6f4ArrivalStart && selectedDate.isBetween(offer6f4ArrivalStart, offer6f4ArrivalEnd, null, '[]')) {
        return true;
    }
    return false;
}

function selectionWithinFourDayFourParks(checkDate) {
    var selectedDate = checkDate || moment(activedate, 'D-M-YYYY');
    if (fourDayFourParksArrivalStart && selectedDate.isBetween(fourDayFourParksArrivalStart, fourDayFourParksArrivalEnd, null, '[]')) {
        return true;
    }
    return false;
}

// 2-Day ticket is off-sale for following year
function offsale() {
    // Show alert
    warning(literal('2-day-ticket-title'), literal('2-day-ticket-message', {
        twoDayStart: moment(twodaystart).format('Do MMMM YYYY'),
        twoDayEnd: moment(twodayend).format('Do MMMM YYYY')
    }));
}

// Display overlay when dynamic pricing API cannot connect; user can disimss
function connectivity() {
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Track in GA
    GA.sendEvent( 'Book', 'Enquiry', 'API Connectivity');
    // Add request class to dialog
    $('#dialog').addClass('request has-image');
    // Show dialog
    modal('#connectivity', false);
}

// Check for offers against active pricing
function offers(selectedDate, featured) {
    // Check if 7 and 14 day adult tickets are the same price
    var seven = getSeasonalPrice('adult', selectedDate, 7);
    var fourteen = getSeasonalPrice('adult', selectedDate, 14);

    // Setup variable
    var message
    // Set offer message
    if (seven == fourteen) {
        // 14 for 7 offer (featured on desktop)
        if (featured) {
            message = literal('special-offer')
        } else {
            message = offer
        }
        // Best selling (featured on desktop)
    } else {
        if (featured) {
            message = literal('best-selling')
        } else {
            message = popular
        }
    }
    // Return
    return message
}

// Paint calendar to show low/mid/high seasonal pricing
function seasons(date) {
    // beforeShowDay must return an array with selectable true/false, CSS (optional), tooltip (optional)
    var isoDate = $.datepicker.formatDate('yymmdd', date) // Convert date object to ISO format
    // First check if active date
    if (coreDates.indexOf(isoDate) > -1) {
        return [true, 'ui-' + isoDate + ' ui-included'];
    }
    else if (bufferDates.indexOf(isoDate) > -1) {
        return [true, 'ui-' + isoDate + ' ui-buffer'];
    }
    else {
        return [true, 'ui-' + isoDate];
    }
}

// Redraw calendar after change to ticket duration/type
function redraw(date, duration) {
    // Redraw
    usage(date, duration);
    // Repaint calendar
    $('#ui-datepicker-inline').datepicker('refresh');
    typeof updateReactApp === 'function' && updateReactApp();
}

// Core ticket selection
function selection(date, setup) {
    // Function will only be triggered by non-calender selection in the event of duration chnage
    updateTicketOptions(date);
    var duration = parseInt($('.duration input:radio:checked').val());
    var selectedType = $('.type input:radio:checked').val();

    if (selectedType === '4' && !selectionWithinFourDayFourParks(moment(date, 'D-M-YYYY'))) {
        $('#fourteen').prop('checked', true);   
        selectedType = $('.type input:radio:checked').val();
        duration = 14;
    }

    // If this is not the setup call
    if (!checkHasStockInDate(moment(date, 'D-M-YYYY').format('YYYYMMDD'), selectedType)) {
        usage(date, duration);
        tickets();
        activedate = date;
        activeduration = duration;
    } else if (!setup) {

        // If neither the date or duration have changed then exit the function
        if ((date == activedate) && (duration == activeduration)) { return; }
        // First check for valid pricing, and revert to previously selected date if API call fails
        pricing(date, duration, function (result) {
            // Pricing API could not return pricing so revert and show modal (e.g. user offline)
            if (!result) { revert(); }
            // Otherwise we have valid pricing
            else {
                // Determine usage window
                usage(date, duration);
                // Call tickets() to update pricing, etc.
                tickets();

            }
        });
        // Setup call needs usage window
    } else {
        // Determine usage window
        usage(date, duration);
    }
}

function updateTicketOptions(date) {
    var arrival = moment(date, 'D-M-YYYY');
    if (arrival.isAfter(waterParksOpenDate)) {
        $('.type.plus').removeClass('disabled');
        $('#plus').prop('disabled',false);
        //$('.type.plus').off('click');
    } else {
        $('.type.plus').addClass('disabled');
        if ($('#plus').prop('checked')) {
            $('#base').prop('checked',true);
        }
        $('#plus').prop('disabled',true);
        //$('.type.plus').on('click', showWaterParksClosed);
    }

    $('.type.four').toggleClass('disabled-4d4p', !selectionWithinFourDayFourParks(arrival));
}

function showWaterParksClosed() {
    dismissable = true;
    $('#dialog').addClass('dismissable has-buttons warning');
    modal('#water-parks-closed', false);

    $('#water-parks-closed .button').on('click', function(){
        waterParksAccepted = true;
        $('#form').submit();
    })
}

// Calculate buffer days, with Park Hopper Plus enjoying +1 day
function buffer(duration) {
    // Ticket type selected?
    var type = $('.type input:radio:checked').val();
    // Calculate buffer days based on duration/type
    var bufferDays;
    // Delta (EMEA)
    if (delta) {
        switch (duration) {
            case 1:
                bufferDays = 0;
                break;
            case 2: case 3:
                bufferDays = 2;
                break;
            case 4: case 5: case 6: case 7:
                bufferDays = 3;
                break;
            case 8: case 9: case 10:
                bufferDays = 4;
                break;
        }
        // Park Hopper Plus enjoys +1 day
        if (type == plus) { bufferDays++; }
        // Magic (UK & Ireland)
    } else if (magic) {
        switch (duration) {
            case 7:
                bufferDays = 8;
                break;
            case 14:
                bufferDays = 4;
                break;
            case 4:
                bufferDays = 3;
                break;
        }
    }
    // Return buffer days
    return bufferDays;
}

// Determine core/buffer days
function usage(date, duration) {
    // Convert date to moment (d-m-yyyy)
    var arrival = moment(date, 'D-M-YYYY');

    // Reset arrays for the core/buffer dates
    coreDates = [];
    bufferDates = [];

    // Core dates
    coreDates.push(arrival.format('YYYYMMDD'));
    for (i = 1; i < duration; i++) {
        coreDates.push(arrival.add(1, 'd').format('YYYYMMDD'));
    }
    // Buffer days
    for (i = 1; i <= buffer(duration) ; i++) {
        bufferDates.push(arrival.add(1, 'd').format('YYYYMMDD'));
    }
    if (ticketdiscount && activetype === '14') {
        $('#ticket-discount-price-message').show().text('Your ' + ticketdiscount + "% discount has been applied!");
    } else {
        $('#ticket-discount-price-message').hide();
    }


    checkAvailability(coreDates[0]);
}

// Revert date/duration
function revert() {
    // Convert active date to moment
    var revertDate = moment(activedate, 'D-M-YYYY')
    // Check for valid active date to revert datepicker
    if (moment(revertDate).isValid()) {
        // Revert date on datepicker/input
        $('#ui-datepicker-inline').datepicker('setDate', activedate);
    }
    // Revert duration
    $('.duration input:radio[data-ticket="' + activeduration + '"]').prop('checked', true);
    // Show modal explaining connectivity failure
    connectivity();
}

// Return/store cached prices to improve performance
function priceCache(retrieve, date, duration, prices) { // Get=true or set=false, date, durtaion, 6 x prices array (can be null for get)
    // Price cache key is made of date-duration
    var cacheKey = date + '-' + duration;
    // Getting prices
    if (retrieve) {
        // Check if entry exists in array
        if (typeof pricingCache[cacheKey] !== 'undefined' && pricingCache[cacheKey] !== null) {
            // Otherwise return pricing
            return pricingCache[cacheKey];
        }
        // Setting prices
    } else {
        // Store array of 6x prices within cache array
        pricingCache[cacheKey] = prices;
    }
}

function getWayForwardDateForApi() {
    const today = moment().format('YYYY-MM-DD');
    const rawCookie = (document.cookie.match(/(?:^|;\s*)wayforward=([^;]*)/) || [])[1];

    if (!rawCookie) {
        return today;
    }

    // Decode the cookie before splitting it into its parameters.
    let cookieValue;
    try {
        cookieValue = decodeURIComponent(rawCookie);
    } catch (e) {
        return today;
    }

    const valuePart = cookieValue
        .split('&')
        .find(part => part.toLowerCase().startsWith('value='));

    const dateValue = valuePart
        ? valuePart.substring('value='.length)
        : '';

    if (!dateValue) {
        return today;
    }

    const formats = [
        moment.ISO_8601,
        'YYYY-M-D',
        'DD/MM/YYYY HH:mm:ss',
        'M/D/YYYY h:mm:ss A',
        'M/D/YYYY HH:mm:ss',
        'D/M/YYYY H:mm:ss'
    ];

    const parsedDate = moment(dateValue, formats, true);

    return parsedDate.isValid()
        ? parsedDate.format('YYYY-MM-DD')
        : today;
}

// Call to local prices API
function getPrices(date, duration, callback) {
    // Build URL for API call
    var wayForwardDate = getWayForwardDateForApi();
    // Build URL for API call
    var buildAPI = ticketsAPI + moment(date, 'D-M-YYYY').format('YYYY-MM-DD') + '/' + duration + '/?wayForwardDate=' + encodeURIComponent(wayForwardDate);  
    // Call API
    $.getJSON(buildAPI, function (data) {
        // Pricing API returned response so loop through JSON
        ticketdiscount = 0;
        if (Object.values(data).some( values => values === 99999)) {
            datesPricedTooHigh.push( moment(date, 'D-M-YYYY').format('YYYYMMDD'));
            selection(date);
            return false;
        }
        $.each(data, function (key, val) {
            // Get response and update existing variables
            // Delta (EMEA)
            if (delta) {
                switch (key) {
                    case 'adultbase': adultbase = parseFloat(val); break;
                    case 'childbase': childbase = parseFloat(val); break;
                    case 'adulthopper': adulthopper = parseFloat(val); break;
                    case 'childhopper': childhopper = parseFloat(val); break;
                    case 'adultplus': adultplus = parseFloat(val); break;
                    case 'childplus': childplus = parseFloat(val); break;
                }
                // Magic (UK & Ireland)
            } else if (magic) {
                switch (key) {
                    case 'adultmagic': adultmagic = parseFloat(val); break;
                    case 'childmagic': childmagic = parseFloat(val); break;
                    case 'ticketdiscount': ticketdiscount = parseFloat(val); break;
                }
            }
        });
        // Update active date, duration, prices
        activedate = date;
        activeduration = duration;
        if (delta) {
            activeprices = [adultbase, childbase, adulthopper, childhopper, adultplus, childplus];
        } else if (magic) {
            activeprices = [adultmagic, childmagic, ticketdiscount];
            calculatePricesTooHigh();
        }
        // Store prices for selected date in cache to support revert if API fails on next call
        priceCache(false, activedate, activeduration, activeprices);
        // Return true in callback
        callback(true);
    })
        // Call fails
        .fail(function (xhr) {
            callback(false);
        });
}

// Call to pricing API for Delta tickets (post Oct '18)
function pricing(date, duration, callback) {
    // First check if we have the selected date/duration stored in the local JS pricing cache
    var cache = priceCache(true, date, duration, null);
    // If we don't have a cached price then call the pricing API
    if (typeof cache === 'undefined') {
        // Call API, with one retry for failure
        getPrices(date, duration, function (result) {
            // Valid response
            if (result) {
                callback(true);
                // Otherwise call failed so retry once
            } else {
                getPrices(date, duration, function (result) {
                    // Now response is okay
                    if (result) { callback(true); }
                    // Still API error
                    else { callback(false); }
                });
            }
        });
        // Otherwise we have cached pricing so can update the UI without an API call
    } else {
        // Populate pricing variables from cache
        // Delta (EMEA)
        if (delta) {
            adultbase = parseFloat(cache[0]);
            childbase = parseFloat(cache[1]);
            adulthopper = parseFloat(cache[2]);
            childhopper = parseFloat(cache[3]);
            adultplus = parseFloat(cache[4]);
            childplus = parseFloat(cache[5]);
            // Magic (UK & Ireland)
        } else if (magic) {
            adultmagic = parseFloat(cache[0]);
            childmagic = parseFloat(cache[1]);
            ticketdiscount = parseFloat(cache[2]);
        }
        // Update active date, duration, prices
        activedate = date;
        activeduration = duration;
        // Return true in callback
        callback(true)
    }
}

// Update messaging to reflect usage window
function visitation(selecteddate, ticket) {
    // Convert usage start date to moment
    var start = moment(selecteddate, 'D-M-YYYY');
    // Determine duration plus buffer (-1 as usage window is inclusive of last day)
    var duration = ticket + buffer(ticket) - 1
    // Write usage window
    var dates = '<span class="no-wrap">' + start.format('Do MMM YYYY') + '</span> - <span class="no-wrap">' + start.add(duration, 'days').format('Do MMM YYYY') + '</span>';
    if (exception14Days) {
        $('div.usage .window h3').html(literal('usage-window-valid-from-14f7', { ticket, dates }))
    }
    else {
        $('div.usage .window h3').html(literal('usage-window-valid-from', { ticket, dates }))
    }
}

// -------------------------------------------------------------------------------------------------------------------

// Manage ticket prices and on-page display
function tickets() {
    var selectedType =$('.type input:radio:checked').val();

    activetype = selectedType;

    if (dateinput == 'menu') {
        var selectedyear = parseInt($('#month').val().split('^')[1]);
    }
    // Check pax
    var adults = parseInt($('#adults').val());
    var children = parseInt($('#children').val());
    // Check ticket duration
    var ticket = parseInt($('.duration input:radio:checked').val());
    // Check arrival date via hidden input field
    var selecteddate = $('#date').val();
    //Convert selected date to an object
    var selecteddateobject = getOutboundDate(dateinput).toDate();
    // -------------------------------------------

    // Ultimate Ticket prices vary between years
    if (!tpt) {
        // -------------------------------------------
        // 2-Day Ticket not on sale
        if (!twoday) {
            // Set offer message
            $('.ticket[data-duration="14"] strong.offer').text(offers(selecteddateobject, false));
        }
            // -------------------------------------------
        // 2-Day Ticket on sale
        else {
            // 2-Day Ticket is available for the arrival date
            if (twodaystart.getTime() <= selecteddateobject.getTime() && selecteddateobject.getTime() <= twodayend.getTime()) {
                $('.two').removeClass('suspended'); // Enable
                $('.two input').prop('disabled', false); // Enable radio button
            }
            // 2-Day Ticket is not available for the arrival date
            else {
                if (ticket == 2) { $('input:radio[value="14"]').prop('checked', true); ticket = 14; } // Switch to 14 day ticket
                $('.two').addClass('suspended'); // Disable
                $('.two input').prop('disabled', true); // Disable radio button
                // Close entitlements panel, if open (mobile)
                if (mobile) {
                    var panel = $('.two .entitlements'); if (panel.hasClass('open')) { entitlements(panel); }
                }
            }
            // Set offer message (desktop/mobile)
            if (!mobile) { $('.featured').text(offers(selecteddateobject, true)); };
            if (mobile) { $('.ticket[data-duration="14"] strong.offer').text(offers(selecteddateobject, false)); };
        }
        // -------------------------------------------
        // Recalculate prices based on year change
        // -------------------------------------------
        // Update all prices to reflect current year
        $("#tickets .ticket").each(function () {
            // Get duration
            var duration = parseInt($(this).attr('data-duration'));
            // Get price and calculate per day
            var adult =  getSeasonalPrice('adult',selecteddateobject, duration);
            var child = getSeasonalPrice('child', selecteddateobject, duration);
            // -------------------------------------------
            // Are we showing was/now pricing?
            // var was = $('.was').length;
            // Are we showing per/day pricing?
            // var day = $('.day').length;
            // -------------------------------------------
            // Update adult prices
            $(this).find('.adult .total').text(formatPrice(adult))
            $(this).find('.adult .day').text(Math.ceil(adult / duration))
            // Hide saving when not 2017
            if (selectedyear != 2017) { $(this).find('.was').hide() } else { $(this).find('.was').show() }
            // Update child prices
            $(this).find('.child .total').text(formatPrice(child))
            $(this).find('.child .day').text(Math.ceil(child / duration))
        })
        // -------------------------------------------
        // Set lead-in price in title; 14 day ticket will always yield best per-day rate
        $("#lead").text(Math.ceil(getSeasonalPrice('adult', selecteddateobject , '14') / 14));
        // Update current year
        activeyear = selectedyear;
    }

    // -------------------------------------------
    // -------------------------------------------
    const ticketSelectionNotAvailable = !checkHasStockInDate(moment(selecteddate, 'D-M-YYYY').format('YYYYMMDD'), activetype)
    // Magic Your Way/Delta (EMEA) or Magic (UK & Ireland)
    if (tpt) {

        // Delta/Magic only
        if (delta||magic) {
            // Repaint calendar to reflect buffer days
            redraw(selecteddate, ticket);
            // Update calendar messaging (desktop/mobile)
            $('div.calendar span.day').text(ticket)
        }

        //MYW/Delta need different handlers
        if (magicyourway||delta) {

            // Check ticket type
            var type = $('.type input:radio:checked').val();

            // Update ticket duration (desktop/mobile)
            $('div.options .type span.day').text(ticket)
            // Update ticket prices for base/hopper/plus
            $("div.options .type").each(function () {
                // Get ticket type/entitlements
                var tickettype = $(this).attr('data-type');
                var ticketincluded = $(this).attr('data-included');

                // Get MYW adult/child prices (static)
                if (magicyourway) {
                    var adultprice = eval('adult' + tickettype + ticket)
                    var childprice = eval('child' + tickettype + ticket)
                    // Get Delta ticket prices (dynamic)
                } else if (delta) {
                    var adultprice = eval('adult' + tickettype)
                    var childprice = eval('child' + tickettype)
                }

                // Update ticket prices
                $(this).find('.adult .price').text(formatPrice(adultprice))
                $(this).find('.child .price').text(formatPrice(childprice))
                // Update number of adults/children
                $(this).find('.adult .total').text(adults)
                $(this).find('.child .total').text(children)
                // If zero children then hide child price
                if (children == 0) {
                    $(this).find('.child').removeClass('show').addClass('hide');
                } else {
                    $(this).find('.child').removeClass('hide').addClass('show');
                }
                // Calculate ticket total
                var tickettotal = formatPrice((adults * adultprice) + (children * childprice));
                // Update ticket total
                $(this).find('div.total span').text(tickettotal)
                // Is this the selected ticket type?
                var ticketselection = $(this).find('input:radio').prop('checked');
                // If yes, then update summary
                if (ticketselection) {
                    // Update summary
                    // Ticket type inclusion
                    $('#summary span.included').text(literal('ticketname-with') + ' ' + ticketincluded)
                    // Update ticket type total
                    $('#summary #adult .sum').text(formatPrice(adults * adultprice))
                    $('#summary #child .sum').text(formatPrice(children * childprice))
                    // Update per-ticket price
                    $('#summary #adult .price').text(formatPrice(adultprice))
                    $('#summary #child .price').text(formatPrice(childprice))
                    // Update total
                    $('#summary .cost span').text(tickettotal)
                    priceDisplayed = tickettotal;
                }
                if (ticketSelectionNotAvailable) {
                    $('#summary p > strong').hide()
                    $('#summary p > em').hide()
                    // Update total
                    $('.summary .price').hide()
                } else {

                    $('.summary .price').show()
                    $('#summary p > strong').show()
                    $('#summary p > em').show()
                }

                [['base','TBT'],['hopper','THT'],['plus','TPT']].forEach( ([className, ticketType]) => {
                    if (!checkHasStockInDate(moment(selecteddate, 'D-M-YYYY').format('YYYYMMDD'), ticketType)) {
                        $('.' + className + ' .pax p > strong').hide()
                        $('.' + className + ' .pax p > em').hide()
                        $('.' + className + ' div.total h2 span').html('&nbsp;')
                    } else {
                        $('.' + className + ' .pax p > strong').show()
                        $('.' + className + ' .pax p > em').show()
                        //$('.' + className + ' div.total').show()
                    }
                } );

            })

            // Magic Tickets need different handlers
        } else if (magic) {

            // Get Magic ticket prices (date-based)
            var adultprice = adultmagic;
            var childprice = childmagic;

            // Genie+
            var genieplus = false;
            var genieprice = 0;
            if (ticket === 7 || ticket === 14) {
                genieprice = typeof window['genieplus' + ticket] !== 'undefined' ? window['genieplus' + ticket] : 0;
            }

            // Checkbox ticked?
            if ($("#genieplus").is(':checked')) { genieplus = true; }

            // Update per-day/total Genie+ pricing
            $('.genieplus .pricing .perday').text(formatPrice(genieprice/ticket))
            $('.genieplus .pricing .perticket').text(formatPrice(genieprice))

            // Recalculate pricing and show inclusion
            var addonincluded = '';

            if (genieplus) {
                // Show Genie+ in summary
                addonincluded = 'with Disney Genie+ Service'
                adultprice += genieprice;
                childprice += genieprice;
            }

            // Calculate ticket total
            var tickettotal = formatPrice((adults * adultprice) + (children * childprice));

            // Update summary

            // Show Genie+ inclusion
            if (ticketSelectionNotAvailable) {
                $('#summary p > strong').hide()
                $('#summary p > em').hide()

                // Update total
                $('.summary .price').hide()
                $('#ticket-discount-price-message').hide()
            } else {
                $('.summary .price').show()
                if (ticketdiscount && activetype === '14') {
                    $('#ticket-discount-price-message').show()
                }
                $('#summary p > strong').show()
                $('#summary p > em').show()

                $('#summary span.included').text(addonincluded) // Genie+
                // Update ticket type total
                $('#summary #adult .sum').text(formatPrice(adults * adultprice))
                $('#summary #child .sum').text(formatPrice(children * childprice))
                // Update per-ticket price
                $('#summary #adult .price').text(formatPrice(adultprice))
                $('#summary #child .price').text(formatPrice(childprice))
                // Update total

                $('#summary .cost span').text(tickettotal)
                priceDisplayed = tickettotal;
            }

        }

        // Update summary panel (all ticket types)

        //Update
        $('#summary span.days').text(ticket)

        if (activetype === "4") {
            $('#summary span.ticket-with').text("");
            $('#summary span.postfix').text("");
            $('#summary-ticket-regular').hide();
            $('#summary-ticket-U44P').show();
        } else {
            $('#summary-ticket-regular').show();
            $('#summary-ticket-U44P').hide();
            const $el = $('#summary span.ticket-with');

            // Only update if it isn't already correct
            if ($el.text().trim() !== literal('ticket-with')) {
                $el.text(literal('ticket-with'));
                $('#summary span.postfix').text(literal('ticket-with-postfix'));
            }
        }
        // Update pax
        $('#summary #adult .total').text(adults)
        $('#summary #child .total').text(children)
        // If zero children then hide child price
        if (children == 0) {
            $('#summary #child').removeClass('show').addClass('hide');
        } else {
            $('#summary #child').removeClass('hide').addClass('show');
        }

        // Update usage window for Delta
        if (delta||magic) { visitation(selecteddate, ticket); }

        // -------------------------------------------
        // -------------------------------------------

        // Ultimate Tickets (UK/Ireland)
    } else {
        // Update itinerary (desktop only)
        if (desktop) {
            // Set ticket name
            var ticketname = $('input:radio:checked').attr('data-ticket');
            $('#itinerary h4.tickets').text(ticketname);
            // Set number of tickets
            $('#adult .total').text(adults);
            $('#child .total').text(children);
            // Set ticket pricing
            $('#adult .ticket').text(getSeasonalPrice('adult',selecteddateobject, ticket));
            $('#child .ticket').text(getSeasonalPrice('child', selecteddateobject, ticket));
        }
        // -------------------------------------------
        // Set total (desktop/mobile)
        var total = formatPrice((adults * getSeasonalPrice('adult',selecteddateobject, ticket)) + (children * getSeasonalPrice('child', selecteddateobject, ticket)));
        $('div.total .cost span').text(total)
        priceDisplayed = total;
    }
    if ($('.offer-6f4-summary-message').length) {
        $('.offer-6f4-summary-message').hide();
        $('#tickets .duration').addClass('offer-6f4-active');

        if (selectionWithin6f4Offer()) {
            if (activeduration === 6) {
                $('.offer-6f4-summary-message').show();
            }
        }
    }
    sendTicketStoreGAEvent()
}

// Format price, with comma for £999+ and correct decimals
function formatPrice(val) { return parseFloat(val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); }

function selectedGuestCount() {
    var sum = 0;
    $('.selector').each(function () {
        var val = $(this).find('input').val();
        sum = sum + parseInt(val);
    });

    return sum;
}

function setModalForTicketsMaxPassengersError() {
    $('#dialog').addClass('dismissable');
    modal('#tickets-max-passengers-error', false);
}

// Get dates for validation
function valid() {
    // Get outbound date and convert to moment
    var outbound = getOutboundDate(dateinput)
    var inbound = outbound.add(activeduration - 1, 'days');

    // Is the outbound journey before a temporary closure end date?
    var tempClosure = $('#ticket-dates').attr('data-temporary-closure-end');
    if (tempClosure != null) {
        var tempClosureDate = moment(tempClosure, "DD/MM/YYYY").toDate();
        if (outbound.isBefore(tempClosureDate)) {
            warning(literal('search.sorry-min-tickets-date'), literal('search.tickets-min-date'));
            return false;
        }
    }

    if (inbound.isAfter(moment(maxdate))) {
        warning(literal('search.tickets-not-on-sale-title', { maxDate: moment(maxdate).format('LL') }), literal('search.tickets-not-on-sale-body'));
        return false;
    }

    // Is the outbound journey after the brochure end date?
    var brochureClosure = $('#ticket-dates').attr('data-brochure-end');
    if (brochureClosure != null) {
        var brochureClosureDate = moment(brochureClosure, "DD/MM/YYYY").toDate();
        if (outbound.isAfter(brochureClosureDate)) {
            warning(literal('search.sorry-min-tickets-date'), literal('search.tickets-max-date', { maxDate: moment(brochureClosureDate).format('Do MMMM YYYY') }));
            return false;
        }
    }
    // Bookings must be a minimum of 3 days from today for ticket only
    var minimum = moment().add(3, 'd');
    var minimumdays = 3;
    // Override minimum for travel agents
    if (agent) { minimum = moment().add(17, 'd'); minimumdays = 17; } // Bookings must be a minimum of 17 days from today for agents against all product types
    // Check eligible departure date
    if (outbound.isBefore(minimum)) {
        warning(literal('search.within-x-days', { days: minimumdays }), literal('search.within-x-days-again-message'));
        return false;
    }

    if (outbound.isSameOrBefore(waterParksOpenDate) && !waterParksAccepted && !delta) {
        showWaterParksClosed(activedate);
        return false;
    }
    // Post form
    return true;
}

function getOutboundDate(dateinput) {
    // Get outbound date and convert to moment
    var outbound
    // Delta tickets use calendar, not drop menus
    if (dateinput == 'calendar') {
        // Get date from hidden field
        outbound = moment($('#date').val(), 'D-M-YYYY');
        // Ultimate/MYW use drop menus, so get outbound date and convert to date object
    }
    else {
        var monthyear = $('#month').val();
        var year = parseInt(monthyear.split('^')[1]);
        var month = parseInt(monthyear.split('^')[0])
        var day = parseInt($('#day').val());
        // Set outbound
        outbound = moment(day + '-' + month + '-' + year, 'D-M-YYYY');
    }
    return outbound
}

function collapse() {
    $('#overlay').hide();
    $('#interstitial').hide();
    $('#dialog').removeClass();
    $('.modal').addClass('hide');
    fixBody(false);
}

function calculatePricesTooHigh() {
    if (adultmagic === 99999 || childmagic === 99999) {
        var formattedDate = moment(activedate, 'D-M-YYYY').format('YYYYMMDD');
        if (!datesPricedTooHigh.includes(formattedDate)) {
            datesPricedTooHigh.push(formattedDate);
        }
    }
}

// -------------------------------------------------------------------------------------------------------------------

// On ready
$(document).ready(function () {

    // -------------------------------------------
    $('.type.plus').on('click', showWaterParksClosed);

    $('#dialog .close').on('click', collapse);

    // Floating datepicker (desktop only for Ultimate/MYW)
    if ((dateinput == 'menu') && (desktop)) {
        // Set datepicker defaults
        $.datepicker.setDefaults({
            dateFormat: 'dd-mm-yy',
            showOn: 'button',
            buttonText: '',
            firstDay: 1,
            prevText: '',
            nextText: '',
            hideIfNoPrevNext: true,
            showOtherMonths: true,
            showAnim: '',
            onClose: function (inst) { calendar(inst.id); $('div.calendar').addClass('shadow'); },
            onSelect: function (dateText, inst) { date(inst.selectedDay, inst.selectedMonth, inst.selectedYear); },
            beforeShow: function () { $('div.calendar').removeClass('shadow'); }
        });
        // Fix position of datepicker
        $.extend($.datepicker, { _checkOffset: function (inst, offset, isFixed) { return offset } });
        // Initialise datepicker against input field (floating)
        $('#date').datepicker({ minDate: mindate, maxDate: maxdate });
    };

    // -------------------------------------------

    // Inline datepicker (desktop/mobile for Delta/Magic)
    if (dateinput == 'calendar') {

        // Store starting date/duration/type for comparison, caching, or to revert
        activedate = $('#date').val();
        activeduration = parseInt($('.duration input:radio:checked').val());
        activetype = $('.type input:radio:checked').val();

        // Plus store active prices in cache at setup
        if (delta) {
            var activeprices = [adultbase, childbase, adulthopper, childhopper, adultplus, childplus];
        } else if (magic) {
            var activeprices = [adultmagic, childmagic, ticketdiscount];
        }

        if (activeprices.some( values => values === 99999)) {
            datesPricedTooHigh.push( moment(activedate, 'D-M-YYYY').format('YYYYMMDD'));
        }

        // Store prices for selected date in cache to support revert if API fails
        priceCache(false, activedate, activeduration, activeprices);

        // Determine usage window before initialising datepicker (setup is true, called from tickets() is false)
        selection(activedate, true);

        // Set datepicker defaults
        $.datepicker.setDefaults({
            dateFormat: 'd-m-yy',
            defaultDate: activedate,
            altField: '#date',
            altFormat: 'dd-mm-yy',
            firstDay: 1,
            prevText: '',
            nextText: '',
            // hideIfNoPrevNext:true,
            showOtherMonths: true,
            onSelect: function (date) { selection(date, false); },
            beforeShowDay: function (date) { return seasons(date); }
        });
        // Initialise datepicker against div (inline)
        if (!$('#tickets-app').length) {
            $('#ui-datepicker-inline').datepicker({ minDate: mindate, maxDate: maxdate });
        }

        if (desktop) {
            $.datepicker.setDefaults({
                dayNamesMin: $.datepicker._defaults.dayNamesShort
            });
        }

    };

    // -------------------------------------------

    // All ticket products and devices

    // Trigger functions and set listeners for drop-menu date input
    if (dateinput == 'menu') {
        // Setup menus
        days();
        // Search form
        $('#month').change(function () { days(); tickets(); });
        $('#day').change(function () { calendar(); tickets(); }); // Update calendar
        // Listen for changes to date hidden field via datepicker
        $('#date').change(function () { tickets(); });
    }

    // Delta/Magic tickets need to handle inputs differently
    if (delta) {
        $('.duration input:radio').change(function () { selection(activedate, false); check6f4Modal(); });
        $('.type input:radio').change(function () { tickets(); });
        // Listen for ticket duration and Genie checkbox
    } else if (magic) {
        $('.duration input:radio').change(function () { selection(activedate, false); });
        $('input:checkbox').change(function () { tickets(); });
        // Otherwise all radio button inputs call tickets()
    } else {
        $('input:radio').change(function () { tickets(); });
    }

    // All ticket types update  pricing based on ticket/pax selections
    $('#adults, #children').change(function () { tickets(); });

    // Initialise page to ensure correct pricing after 'Back' in browser
    tickets();

    // -------------------------------------------

    // Show entitlments in sliding panel (mobile only)
    if (mobile) {
        // Listen for click
        $(".entitlements").click(function (event) {
            // Prevent event from bubbling up the DOM tree
            event.preventDefault();
            event.stopImmediatePropagation();
            // Set $(this) as variable
            var panel = $(this);
            // Is this ticket suspended?
            if (panel.closest('.ticket').hasClass('suspended')) {
                /// If yes, then show alert
                offsale();
                // Else slide panel and manage norgie
            } else {
                entitlements(panel)
            }
        });
    }

    // -------------------------------------------

    // Guest selection
    $('.selector .minus, .selector .plus').click(function () { selectguests($(this)); });

    // -------------------------------------------

    // Alerts (desktop)

    // Show details of 14 for 7 special offer
    $('.featured').click(function () {
        if ($(this).text() == literal('special-offer')) {
            warning(literal('special-offer-title'), literal('special-offer-message', {
                expireDate: moment(expire).format('Do MMMM YYYY'),
                expireYear: moment(expire).year()
            }));
        }
    });

    // Show alert on 2-Day Ticket for next year's arrivals
    $('.two').click(function () { if ($(this).hasClass('suspended')) { offsale() }; });

    // XXX
    $('.usage-explained').click(function () { explained(); });

    // -------------------------------------------

    // Validate input
    $('#form').submit(function (event) {
        // Prevent DOM from unloading before we have fired the tracking code
        if (!selectionValid) {
            warning(literal('ticketAvailability.selection-unavailable-click-button-title'),literal('ticketAvailability.selection-unavailable-click-button-message'));
            return false;
        }
        event.preventDefault();
        // Set this form to be a variable
        var form = this;

        if (selectedDateBetweenGiftCardWindow() && !giftCardModalForceContinue && activeduration < 3) {
            showGiftCardModal();
            return;
        }

        if (selectedGuestCount() > 10) {
            setModalForTicketsMaxPassengersError();
            return;
        }

        // Valid date?
        if (valid()) { form.submit(); }
    });

});

 $('.type.four').click(function (e) {
    	if (!selectionWithinFourDayFourParks()) {
		warning(literal('fourdayfourparks-offer-title'), literal('fourdayfourparks-offer-message', {
			arrivalStart: fourDayFourParksArrivalStart ? fourDayFourParksArrivalStart.format('DD MMMM') : '',
			arrivalEnd: fourDayFourParksArrivalEnd ? fourDayFourParksArrivalEnd.format('DD MMMM YYYY') : ''
		}));
            	e.preventDefault();
	        return;
}
});


function selectedDateBetweenGiftCardWindow(){
    var selectedDate = moment(activedate, 'DD-MM-YYYY');
    return typeof giftCardOfferArrivalStart !== 'undefined' && selectedDate.isSameOrAfter(giftCardOfferArrivalStart) && selectedDate.isSameOrBefore(giftCardOfferArrivalEnd);
}

function showGiftCardModal(){
    dismissable = true;

    $('#dialog').addClass('dismissable');
    $('#dialog').addClass('warning has-buttons');
    modal('#gift-card-offer-miss-out', false);
    $('#gift-card-offer-miss-out .button').click(function() {
        giftCardModalForceContinue = true;
        $('#form').submit();
    });
}

function showOffer6f4Modal() {
    dismissable = true;

    $('#dialog').addClass('dismissable');
    $('#dialog').addClass('warning has-buttons');
    modal('#upsell-offer-6f4-tickets', false);
    $('#upsell-offer-6f4-tickets .cancel').click(function () {
        dismiss();
    });
    $('#upsell-offer-6f4-tickets .button').click(function () {
        $('.duration #6-day').prop('checked',true);
        $('.duration #6-day').change();
       dismiss();
    });
}

function toggleTicketsAvailable(enable) {
    selectionValid = enable;
    $('.confirm .button').toggleClass('disabled', !enable)
}
function checkHasStockInDate(date, type) {
    var checkType = type || activetype;
    if (datesPricedTooHigh.includes(date)) {
        return false;
    }
    const doCheck = (datesArray) => {
        let isNotAvailable =  datesArray[date] && datesArray[date][checkType];
        if (isNotAvailable && (checkType !== "14" && checkType !== "7")) {
            isNotAvailable = datesArray[date][checkType].includes(activeduration);
        }
        return isNotAvailable;
    }

    return !(doCheck(noStockDates) || doCheck(noAvailabilityDates));
}
function checkAvailability(date){
    noStockInSelectedDate = false;
    noCapacityInSelectedDate = false;
    exception14Days = false;
    var message = '';
    var title = '';

    if (!checkHasStockInDate(date)) {
        noStockInSelectedDate = true;
        message = literal('ticketAvailability.selection-stock-unavailable',{
            ticketDate: moment(date).format(literal('dates.day-and-full-month')),
            duration: activeduration,
            type: literal('ticketTypes.'+activetype) ? literal('with') + ' ' + literal('ticketTypes.'+activetype) : '',
        });
        title = literal('ticketAvailability.selection-unavailable-title');
    } else {
        var noCapacityDatesInSelection = [...coreDates, ...bufferDates].filter(item => noCapacityDates.includes(item)).map(item => moment(item).format(literal('dates.day-and-full-month')));

        if (activetype === '14' && noCapacityDatesInSelection.length && noCapacityDatesInSelection.length <= 4) {
            noCapacityInSelectedDate = false;
            exception14Days = true;
            message += literal('ticketAvailability.14-day-exception-message', {dates: formatDatesList(noCapacityDatesInSelection)});
            title = title || literal('ticketAvailability.14-day-exception-title');
        } else if (noCapacityDatesInSelection.length) {
            noCapacityInSelectedDate = true;
            message += literal('ticketAvailability.selection-unavailable-message', {
                dates: formatDatesList(noCapacityDatesInSelection),
                duration: activeduration,
                thisDatePluralized: noCapacityDatesInSelection.length > 1 ? literal('ticketAvailability.datesPlural') : literal('ticketAvailability.datesSingular'),
            })
            title = literal('ticketAvailability.selection-unavailable-title');
        }
    }

    drawAvailabilityErrors(message,title);
}
function formatDatesList(dates){
    var output = dates.join(', ');
    return output.replace(/(.+),/,'$1 ' + literal('concatenate'))

}
function drawAvailabilityErrors(message,title) {

    if (message.length) {
        if (noStockInSelectedDate || !exception14Days) {
            toggleTicketsAvailable(false);
            $('#tickets-availability-messages').addClass('error');
            $('.frame').addClass('error');
        } else {
            toggleTicketsAvailable(true);
            $('.frame').removeClass('error');
            $('#tickets-availability-messages').removeClass('error');
        }
        $('#tickets-availability-messages').removeClass('collapsed');
        $("#tickets-availability-messages .advisory-text").html(message)
        $("#tickets-availability-messages h3").html(title)

    } else {
        toggleTicketsAvailable(true);
        $('.frame').removeClass('error');
        $('#tickets-availability-messages').addClass('collapsed');
    }
}
function warnTypeNotAvailable(e,item) {
    var selectedType = item.val();
    var selectedDate = moment(activedate, 'DD-MM-YYYY');

    if (!checkHasStockInDate(selectedDate.format('YYYYMMDD'), selectedType)) {
        warning('No stock for type ' + selectedType);
        e.preventDefault();
    }
}

function changeTypeAutomaticallyIfNoStock(date) {
    var formattedDate = date.format('YYYYMMDD');
    var ticketTypes = ['TBT', 'THT', 'TPT'];

    if (ticketTypes.includes(activetype)) {
        ticketTypes.forEach( type => {
            if (!checkHasStockInDate(formattedDate) && checkHasStockInDate(formattedDate, type)) {
                activetype = type;
                $('.type input:radio[value="' + type + '"]').attr('checked',true);
            }
        })
    }
}
function getTicketID() {
    const selectedDate = moment(activedate, 'D-M-YYYY');
    let code;
    let seasonal14f7Date = null;
    let adultForChildStart = null;
    let adultForChildEnd = null;
    if (typeof seasonalofferend !== 'undefined') {
        seasonal14f7Date = moment(seasonalofferend, 'D/M/YYYY');
    }
    if (typeof adultForChildArrivalStart !== 'undefined') {
        adultForChildStart = moment(adultForChildArrivalStart , 'D/M/YYYY');
        adultForChildEnd = moment(adultForChildArrivalEnd , 'D/M/YYYY');
    }
    if (selectedDate.isSameOrAfter(adultForChildStart) && selectedDate.isSameOrBefore(adultForChildEnd)) {
        if (activetype === '14') {
            code = '14AC';
        } else if (activetype === '7') {
            code = '07AC';
        }
        return code;
    }

    if (seasonal14f7Date  && selectedDate.isSameOrBefore(seasonal14f7Date) && activeduration === 14) {
        code = '147D';
    } else {
        if (activetype === '14') {
            code = '14DB';
        } else if (activetype === '7') {
            code = '07DB';
        } 
         else if (activetype === '4') {
            code = 'U44P';
        } 
        else {
            code = (activeduration - 1) + activetype;
        }
    }
    return code;
}
function sendTicketStoreGAEvent(){
    const stopSaleFlag = noStockInSelectedDate || noCapacityInSelectedDate;
    const formattedDate = moment(activedate, 'D-M-YYYY').format('YYYY-MM-DD');
    const ticketId = getTicketID();
    const parsedPrice = priceDisplayed && priceDisplayed.replace(/[^0-9]|(?!^)-/g, '') / 100;
    GA.sendEvent('TicketStore','Detail',formattedDate + "|" + ticketId + "|"  + stopSaleFlag + "|" + parsedPrice);
}

function check6f4Modal() {
    var duration = parseInt($('.duration input:radio:checked').val());
    if (!offer6f4ModalShowAlready && (duration === 4 || duration === 5)) {
        //offer6f4ModalShowAlready = true;
        showOffer6f4Modal();
    }
}
document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
        console.log('Price updated after visibility change');
        pricingCache = [];
        activedate = null;
        selection($("#date").val());
    }
});

    window.addEventListener('pageshow', (e) => {
    console.log('Price updated after pageshow');
    pricingCache = [];
    activedate = null;
    selection($("#date").val());
});